import "../../../../stylesheets/fundraising";
import "../../../../stylesheets/templates/fundraising/template-1";
import "../../../../stylesheets/templates/fundraising/template-2";
import "../../../../stylesheets/templates/fundraising/template-3";
import "../../../../stylesheets/templates/fundraising/template-4";
import "../../../../stylesheets/templates/fundraising/template-5";
import "../../../../stylesheets/templates/fundraising/template-6";
import "../../../../stylesheets/templates/fundraising/template-7";
import "../../../../stylesheets/templates/fundraising/template-1-mobile";
import "../../../../stylesheets/templates/fundraising/template-2-mobile";
import "../../../../stylesheets/templates/fundraising/template-3-mobile";
import "../../../../stylesheets/templates/fundraising/template-4-mobile";
import "../../../../stylesheets/templates/fundraising/template-5-mobile";
import "../../../../stylesheets/templates/fundraising/template-6-mobile";
import { pickTextColorBasedOnBgColorAdvanced } from "../../../utils";
import "./index";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { arrayRandomIndex } from "tsparticles-engine";

var locale = window.locale || "es";

function getViewportWidth() {
  return Math.min(
    document.documentElement.clientWidth,
    window.innerWidth, screen.width || 0
  );
}
function handleMobileView() {
  const width = getViewportWidth();
  if (width <= 768) {
    $("form#new_donator")[0].remove();
  } else {
    $("form#new_donator")[1].remove();
  }
}

handleMobileView();

$(document).ready(function () {
  let lastWidth = getViewportWidth();
  $(window).on("resize orientationchange", function () {
    const currentWidth = getViewportWidth();
    const wasMobile = lastWidth <= 768;
    const isMobile = currentWidth <= 768;

    if (wasMobile !== isMobile) {
      window.location.reload();
    }
    lastWidth = currentWidth;
  });

  $("#payroll_donator_tax_id").on("input", ({ target }) => {
    let val = format(target.value);
    target.value = val;
  });
  $("#payroll-donator-submit-button").on("click", (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = $("#new_payroll_discount");
    form[0].classList.add("was-validated");
    const rutField = $("#payroll_donator_tax_id")[0];
    const rutValidity = rutField ? Fn.validaRut(rutField.value) : true;
    if (rutValidity === false) {
      $("#payroll_donator_tax_id").addClass("is-invalid");
      $("#payroll_donator_tax_id").removeClass("is-valid");
      $("#new_payroll_discount").removeClass("was-validated");
    } else {
      $("#payroll_donator_tax_id").addClass("is-valid");
      $("#payroll_donator_tax_id").removeClass("is-invalid");
      $("#new_payroll_discount").addClass("was-validated");
    }
    if (form[0].checkValidity() === true && rutValidity === true) {
      $("#new_payroll_discount").submit();
    }
  });

  $("[name='recurring_radio']").on("change", function () {
    if (this.value == "subscriptions") {
      $("#donator_email_label").html(
        locale == "en" ? "Enter your email" : "Ingresa tu mail"
      );
    } else if (this.value == "single-donation") {
      $("#donator_email_label").html(
        locale == "en"
          ? "Enter your email <span>(optional)</span>"
          : "Ingresa tu email <span class='optional'>(opcional)</span>"
      );
    }
  });

  // Prevent multiple backdrop on volunteer-stats
  $(document).on(
    "click",
    '[data-toggle="modal"][href="#volunteer-stats"], [data-toggle="modal"][data-target="#volunteer-stats"]',
    function (e) {
      $(".modal-backdrop").not(":last").remove();
    }
  );

  if ($(".template-f3, .template-f3-mobile").length != 0) {
    $(".carousel").slick({
      infinite: true,
      centerMode: true,
      centerPadding: "50px",
      dots: true,
      arrows: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      variableWidth: true,
    });
  }

  let searchParams = new URLSearchParams(window.location.search);
  if (searchParams.get("volunteer_stats") == "true") {
    $(".volunteer-stats").trigger("click");
  }
});
